import { useTranslation } from 'react-i18next';
import { Anchor } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export interface FooterProps {
  className?: string;
  hasCombinedTerms?: boolean;
}

export const Footer = ({ className, hasCombinedTerms }: FooterProps) => {
  const { t } = useTranslation();

  return (
    <footer
      className={cn(
        'mt-auto box-border flex h-[var(--footer-height)] items-end text-base font-light text-secondary',
        className
      )}
    >
      <p css={{ marginRight: 'auto' }}>{t('CopyrightSentence')}</p>
      <Anchor className="px-4 py-0 text-secondary not-disabled:hover:text-secondary" target="_blank" to="/privacy">
        {t('Button.Privacy Policy')}
      </Anchor>
      <p css={{ fontWeight: 100 }}>|</p>
      <Anchor
        className="px-4 py-0 text-secondary not-disabled:hover:text-secondary"
        target="_blank"
        to={hasCombinedTerms ? '/terms-combined' : '/terms'}
      >
        {t('Button.Terms Of Service')}
      </Anchor>
    </footer>
  );
};
